import { ChangeDetectionStrategy, Component, Input, signal, inject, computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from '../v2/login/login.component';
import { SignupComponent } from '../v2/signup/signup.component';
import { VerifyEmailComponent } from '../v2/verify-email/verify-email.component';
import { NgOptimizedImage } from "@angular/common";

@Component({
    selector: 'app-auth-popup',
    templateUrl: './auth-popup.component.html',
    styleUrls: ['./auth-popup.component.scss'],
    imports: [LoginComponent, SignupComponent, VerifyEmailComponent, NgOptimizedImage],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthPopupComponent {
   public activeModal = inject(NgbActiveModal);
   private router = inject(Router);
   private route = inject(ActivatedRoute);

   // Note: Using @Input instead of input() signal here because NgbModal 
   // sets inputs via componentInstance, which is not compatible with InputSignals in the current version.
   @Input() action: string | null = null;
   @Input() dismissRedirect: string | null = null;
   @Input() set formName(value: string) {
       if (value === 'signIn') {
          this.currentStep.set('login');
          this.showEmailLoginForm.set(false);
       }
       else if (value === 'signUp') {
           this.currentStep.set('signup');
           this.showEmailSignupForm.set(false);
       }
   }
   @Input() selectedSignUpUI: 'default' | 'waitlist' = 'default';
   @Input() signupHeaderText: string = '';
   @Input() signupSubheaderText: string = '';
   @Input() loginHeaderText: string = '';
   @Input() loginSubheaderText: string = '';

   currentStep = signal<'login' | 'signup' | 'verify-email'>('login');
   showEmailSignupForm = signal(false);
   showEmailLoginForm = signal(false);


   private queryParamsSignal = toSignal(this.route.queryParams, { initialValue: {} as any });
   authQueryParams = computed(() => {
      const params = this.queryParamsSignal();
      const filtered: any = {};
      const source = params['source'];
      if (source === 'trade' || source === 'academy') {
         filtered['source'] = source;
      }
      return filtered;
   });

   public onEmailOtpSent() {
      this.currentStep.set('verify-email');
   }

   public onEmailVerified() {
      this.activeModal.close();
      this.router.navigate(['/authentication/activate'], { queryParams: this.authQueryParams() });
   }

   public onLoginSuccess() {
      this.activeModal.close();
   }

   public dismiss() {
      if (this.dismissRedirect) {
         this.activeModal.dismiss();
         this.router.navigate([this.dismissRedirect]);
      } else {
         this.activeModal.dismiss();
      }
   }
}